import Link from '@/components/Link';

export default function CertificationDetailsLink({
  url,
}) {
  return (
    <Link href={url} className="text-center w-full flex items-center justify-center bg-gray-900 text-white border border-transparent px-4 py-2 leading-5 rounded-full shadow ring-2 ring-transparent ring-offset-2 ring-offset-white hover:bg-gray-800 focus:outline-none focus:bg-gray-800 focus:ring-gray-800 space-x-2 font-medium transition ease-linear duration-100"> 
      Más información
    </Link>
  );
}
